const routes = [
	{
		path: '/course/course-center-list',
		name: 'course/course-center-list',
		component: () =>
			import('../views/Course/course-center-list.vue')
	},
	{
		path: '/course/file-list',
		name: 'course/file-list',
		component: () =>
			import('../views/Course/file-list.vue')
	},
];

export default {
	routes
};
